/*
 * @FilePath     : /es-package/packages/es-mpx-template/src/plugins/router.js
 * @Author       : LiYang
 * @Date         : 2021-08-12 18:38:49
 * @LastEditTime : 2021-12-30 16:54:27
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import useRouter from "@didi/es-mpx-router";

export default useRouter